import { Filter, Sort } from 'core/util/Search';

export enum Interval {
    Second = 1,
    Minute = 2,
    Hour = 3,
    Day = 4,
    Week = 5,
    Month = 6,
    Quarter = 7,
    Year = 8,
    FiscalWeek = 9,
    FiscalMonth = 10,
    FiscalQuarter = 11,
    FiscalYear = 12,
    None = 13,
}

export interface GroupBy {
    name: string;
    topN?: number;
    label?: string;
    interval?: Interval;
    sorts?: Sort[];
}

export enum MetricType {
    Count = 1,
    Sum = 2,
    Average = 3,
    Min = 4,
    Max = 5,
    UniqueCount = 6,
}

export interface Metric {
    metricType: MetricType;
    name: string;
    label?: string;
}

export interface AggregateRequest {
    filters: Filter[];
    groupBys: GroupBy[];
    metrics: Metric[];
    sorts?: Sort[];
    limit?: number;
}

export interface BatchAggregateRequest {
    aggregateRequests: AggregateRequest[];
}
